import { SERVER } from "../environment.constants";

export class LocationUrl {
    private static location: string = SERVER + "/location";
    public static add: string = LocationUrl.location + "/add";
    public static get: any = (accountSeq: number) => `${LocationUrl.location}/${accountSeq}`;
    public static delete: any = (locationSeq: number) => `${LocationUrl.location}/${locationSeq}`;
    public static deleteAll: any = (accountSeq: number) => `${LocationUrl.location}/${accountSeq}/all`;
    
    public static getLastAltitude: any = (accountSeq: number) => `${LocationUrl.location}/lastAltitude/${accountSeq}`;
}